<template>
		<modal title="Statistiques" :value="statisticsModal" effect="fade" large @cancel="toggleUntoggleStatistic()">
		        <tabs v-model="activeTab" nav-style="pills" justified>
		            <tab header="Résultats" v-if="results">
						<statisticsResultsBlock :user="user" :group="group" :id="id"></statisticsResultsBlock>
					</tab>
		            <tab header="Enquête de satisfaction" v-if="satisfaction">
						<statisticsSatisfactionBlock :user="user" :group="group" :id="id"></statisticsSatisfactionBlock>
					</tab>
				</tabs>
				<div slot="modal-footer" class="modal-footer">
					<a v-if="satisfaction && activeTab == 1" target="_blank" :href="exportUrl" class="btn btn-default">Export PDF</a>
					<button type="button" class="btn btn-default" @click="toggleUntoggleStatistic()">Ok</button>
				</div>
		</modal>
</template>

<script>
	import { tabs as Tabs, tab as Tab, modal as Modal } from 'vue-strap';
	import StatisticsResultsBlock from 'components/StatisticsResultsBlock';
	import StatisticsSatisfactionBlock from 'components/StatisticsSatisfactionBlock';

	export default {
		components: {
			Modal,
			Tab,
			Tabs,
			StatisticsResultsBlock,
			StatisticsSatisfactionBlock
		},
		computed: {
			exportUrl: function()	{
                return this.$store.state.baseUrl + '/export/1/' + this.id + '?token=' + this.$store.state.token;
			},
			statisticsModal: function()	{
				return this.$store.state.statistics.modalStatistics;
			}
		},
		props: {
			user: {type: Boolean, default: false},
			group: {type: Boolean, default: false},
			results: {type: Boolean, default: false},
			satisfaction: {type: Boolean, default: false},
			id: {type: Number, default: 0}
		},
		methods: {
			toggleUntoggleStatistic()	{
		        this.$store.commit('DISPLAY_MODAL_STATISTICS', !this.statisticsModal);
			}
		},
		data: function()	{
			return {
				activeTab: 0
			};
		}
	};
</script>
